module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-8 h-full"
  }, [_c('div', {
    staticClass: "flex flex-col h-full"
  }, [_c('div', {
    staticClass: "flex-grow"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "bg-input text-sm text-gray-600 flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-400",
    attrs: {
      "placeholder": 'Course Tittle',
      "type": "text",
      "disabled": !_vm.is_course_author
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "keyup": _vm.checkIfSettingsHaveChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('p', {
    staticClass: "mt-2"
  }, [_vm._v("Section")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.section),
      expression: "section"
    }],
    staticClass: "bg-input text-sm text-gray-600 flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-400",
    attrs: {
      "placeholder": 'Course Section',
      "type": "text",
      "disabled": !_vm.is_course_author
    },
    domProps: {
      "value": (_vm.section)
    },
    on: {
      "keyup": _vm.checkIfSettingsHaveChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.section = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.hasSchool && _vm.is_course_author) ? _c('div', {
    staticClass: "flex items-center mt-5"
  }, [_c('pl-checkbox', {
    staticClass: "pl-7",
    on: {
      "change": _vm.checkIfSettingsHaveChanged
    },
    model: {
      value: (_vm.is_school_course),
      callback: function($$v) {
        _vm.is_school_course = $$v
      },
      expression: "is_school_course"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n            This is a course in my school:\n            "), _c('span', {
    staticClass: "text-sm text-gray-400 mx-1"
  }, [_vm._v("\n              " + _vm._s(_vm.school.name) + "\n            ")])])], 1) : _vm._e()]), _vm._v(" "), (_vm.is_course_author) ? _c('div', {
    staticClass: "mt-7 flex justify-between"
  }, [_c('div', [_c('button', {
    staticClass: "px-8 py-2 bg-primary rounded cursor-pointer text-white disabled:opacity-50",
    attrs: {
      "disabled": !_vm.settings_have_changed || _vm.title.trim() === ''
    },
    on: {
      "click": _vm.saveSettings
    }
  }, [_vm._v("\n            Save Settings\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "md:flex md:ml-2.5"
  }, [(!_vm.course_is_archived) ? _c('button', {
    staticClass: "mr-2.5 px-8 py-2 bg-blueGray-500 hover:bg-blueGray-600 rounded cursor-pointer text-white",
    on: {
      "click": function($event) {
        _vm.show_archive_course_modal = true
      }
    }
  }, [_vm._v("\n            Archive Course\n          ")]) : _c('button', {
    staticClass: "px-8 py-2 mr-2.5 bg-gray-500 hover:bg-gray-600 rounded cursor-pointer text-white",
    on: {
      "click": _vm.archiveCourse
    }
  }, [_vm._v("\n            Restore Course\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "px-8 py-2 bg-red-500 hover:bg-red-600 rounded cursor-pointer text-white",
    on: {
      "click": function($event) {
        _vm.show_delete_course_modal = true
      }
    }
  }, [_vm._v("\n            Delete Course\n          ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "co-teachers lg:mt-0 md:mt-6 sm:mt-6"
  }, [(_vm.can_add_co_teachers) ? [(_vm.getProfile.role === 'admin') ? _c('div', {
    staticClass: "w-full"
  }, [_c('h6', {
    staticClass: "font-semibold text-sm"
  }, [_vm._v("Author")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-center col-xs-8 p-2 my-2"
  }, [_c('img', {
    staticClass: "rounded-full h-11 w-11",
    attrs: {
      "src": _vm.class_author.avatar_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-4"
  }, [_c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s(_vm.class_author.name))]), _vm._v(" "), _c('p', {
    staticClass: "text-xs text-gray-400"
  }, [_vm._v(_vm._s(_vm.class_author.email))])])])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.co_teachers_in_class), function(coTeacher) {
    return _c('div', {
      key: coTeacher.id,
      staticClass: "flex row flex-row justify-between items-center p-2 w-full"
    }, [_c('div', {
      staticClass: "flex flex-row items-center col-xs-8 p-0"
    }, [_c('img', {
      staticClass: "rounded-full w-11 h-11",
      attrs: {
        "src": coTeacher.avatar_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ml-4"
    }, [_c('p', {
      staticClass: "text-sm"
    }, [_vm._v(_vm._s(coTeacher.name))]), _vm._v(" "), _c('p', {
      staticClass: "text-xs text-gray-400"
    }, [_vm._v(_vm._s(coTeacher.email))])])]), _vm._v(" "), (!coTeacher.subscription.created_from_clever) ? _c('div', {
      staticClass: "flex"
    }, [(!_vm.can_add_co_teachers) ? _c('pl-button', {
      staticClass: "pl-ruby-font float-right",
      attrs: {
        "disabled": true
      }
    }, [_vm._v("\n              Co-Teacher\n            ")]) : _c('button', {
      staticClass: "text-red-500 mr-1 hover:text-red-600",
      on: {
        "click": function($event) {
          return _vm.selectCoTeacherToRemove(coTeacher)
        }
      }
    }, [_c('i', {
      staticClass: "text-base fa-solid fa-trash-can"
    })])], 1) : _vm._e()])
  }), _vm._v(" "), (_vm.can_add_co_teachers) ? _c('div', {
    staticClass: "flex justify-between w-full mt-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.co_teacher_email_to_invite),
      expression: "co_teacher_email_to_invite",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "bg-input text-sm mr-3 text-gray-600 flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-400",
    attrs: {
      "placeholder": _vm.co_teachers_in_class.length >= _vm.allowed_number_of_co_teachers ?
        '' :
        "Enter a Parlay Teacher's Email",
      "type": "text",
      "errorMessage": _vm.email_error,
      "disabled": _vm.co_teachers_in_class.length >= _vm.allowed_number_of_co_teachers
    },
    domProps: {
      "value": (_vm.co_teacher_email_to_invite)
    },
    on: {
      "keyup": [function($event) {
        _vm.email_error = ''
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.inviteCoTeacher.apply(null, arguments)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.co_teacher_email_to_invite = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": _vm.co_teachers_in_class.length >= _vm.allowed_number_of_co_teachers ||
        _vm.co_teacher_email_to_invite.trim() === ''
    },
    on: {
      "click": _vm.inviteCoTeacher
    }
  }, [_vm._v("\n            Invite\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.admins_in_course.length) ? _c('div', {
    staticClass: "flex flex-col text-sm mt-7"
  }, [_c('span', {
    staticClass: "font-semibold"
  }, [_vm._v(" Admins ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.admins_in_course), function(admin) {
    return _c('div', {
      key: admin.id,
      staticClass: "flex row flex-row items-center p-2 w-full"
    }, [_c('div', {
      staticClass: "flex flex-row"
    }, [_c('img', {
      staticClass: "rounded-full w-11 h-11",
      attrs: {
        "src": admin.avatar_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ml-2"
    }, [_c('p', {
      staticClass: "text-sm"
    }, [_vm._v(_vm._s(admin.name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "text-xs text-gray-400"
    }, [_vm._v(_vm._s(admin.email))])])])])
  })] : [_c('div', {
    staticClass: "w-full"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "flex row flex-row items-center",
    staticStyle: {
      "padding": "10px",
      "width": "100%"
    }
  }, [_c('img', {
    staticClass: "rounded-full h-11 w-11",
    attrs: {
      "src": _vm.class_author.avatar_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-2"
  }, [_c('span', {
    staticClass: "pl-subheading"
  }, [_vm._v(_vm._s(_vm.class_author.name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "pl-caption"
  }, [_vm._v(_vm._s(_vm.class_author.email))])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', [(_vm.getCourseDetail.is_sample === true) ? _c('div', [_c('div', {
    staticClass: "flex flex-row mt-3"
  }, [_c('img', {
    staticClass: "rounded-full w-11 h-11",
    attrs: {
      "src": _vm.getProfile.avatar_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-4"
  }, [_c('span', {
    staticClass: "pl-subheading"
  }, [_vm._v(_vm._s(_vm.getProfile.name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "pl-caption"
  }, [_vm._v(_vm._s(_vm.getProfile.email))])])])]) : _c('div', _vm._l((_vm.co_teachers_in_class), function(co_teacher) {
    return _c('div', {
      key: co_teacher.id,
      staticClass: "flex row flex-row items-center p-3 w-full"
    }, [_c('div', {
      staticClass: "flex flex-row"
    }, [_c('img', {
      staticClass: "rounded-full w-11 h-11",
      attrs: {
        "src": co_teacher.avatar_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ml-4"
    }, [_c('span', {
      staticClass: "pl-subheading"
    }, [_vm._v(_vm._s(co_teacher.name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "pl-caption"
    }, [_vm._v(_vm._s(co_teacher.email))])])])])
  }), 0)]), _vm._v(" "), (_vm.admins_in_course.length) ? _c('div', {
    staticClass: "flex flex-col title mt-2"
  }, [_c('span', {
    staticClass: "font-bold"
  }, [_vm._v("Admins")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.admins_in_course), function(admin) {
    return _c('div', {
      key: admin.id,
      staticClass: "flex row flex-row items-center p-3 w-full"
    }, [_c('div', {
      staticClass: "flex flex-row"
    }, [_c('img', {
      staticClass: "rounded-full w-11 h-11",
      attrs: {
        "src": admin.avatar_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ml-2"
    }, [_c('span', {
      staticClass: "pl-subheading"
    }, [_vm._v(_vm._s(admin.name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "pl-caption"
    }, [_vm._v(_vm._s(admin.email))])])])])
  })], 2)]], 2)]), _vm._v(" "), (_vm.show_confirm_co_teacher_removal) ? _c('pl-confirm', {
    attrs: {
      "message": 'Remove Co-Teacher',
      "confirmColor": 'bg-red-500 hover:bg-red-600',
      "confirmText": 'DELETE',
      "typeConfirm": false
    },
    on: {
      "close": function($event) {
        _vm.show_confirm_co_teacher_removal = false
      },
      "confirm": _vm.removeCoTeacher
    }
  }, [_c('div', {
    staticClass: "text-center my-5 text-gray-700 mb-6"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-exclamation text-red-500 text-3xl mb-3"
  }), _vm._v(" "), _c('p', {}, [_vm._v("\n        Are you sure you want to remove\n        "), _c('span', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.co_teacher_selected_to_remove.name))]), _vm._v("\n        from the course?\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.show_delete_course_modal) ? _c('DialogDeleteConfirm', {
    attrs: {
      "subHeader": "This course and its contents cannot be restored after you take this action.",
      "optionalText": "Delete Course"
    },
    on: {
      "close": function($event) {
        _vm.show_delete_course_modal = false
      },
      "actionConfirmed": _vm.deleteCourse
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_archive_course_modal) ? _c('DialogDeleteConfirm', {
    attrs: {
      "header": "Are you sure want to archive this",
      "submitButton": "Archive",
      "labelText": "Please type in \"confirm\" to archive this item",
      "subHeader": "Archiving this course will stop students from being able to see or enter the course. You can restore the course at any time.",
      "optionalText": "Archive Course"
    },
    on: {
      "close": function($event) {
        _vm.show_archive_course_modal = false
      },
      "actionConfirmed": _vm.archiveCourse
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Title "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col mb-3"
  }, [_c('h6', {
    staticClass: "font-semibold text-sm"
  }, [_vm._v("Co-Teachers")]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-400 text-xs"
  }, [_vm._v("\n            Invite other teachers to the course (Optional)\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-4 px-3 py-2 flex items-center bg-gray-200 rounded text-gray-600"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info text-sm mr-2"
  }), _vm._v(" "), _c('p', {
    staticClass: "w-full subpixel-antialiased select-none text-xs flex-grow outline-none mr-2"
  }, [_vm._v("\n            You can only invite teachers that have already signed up to Parlay\n            *\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col title"
  }, [_c('h6', {
    staticClass: "font-bold"
  }, [_vm._v("Author")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col title"
  }, [_c('span', {
    staticClass: "font-bold"
  }, [_vm._v(" Co-teachers ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2a47f027!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/pages/settings/generalSettings.vue
// module id = 1032
// module chunks = 61